import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var productCareDoNotIronIconIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.423 2c1.187 0 2.158.96 2.237 2.175l.005.16V6.46l.592-.39a.93.93 0 0 1 1.256.214l.066.094.258.424-2.172 1.435v9.735l1.487.92c.422.26.584.805.393 1.263l-.056.112-.244.427-3.12-1.928H5.726L1.693 21.43l-.258-.425a1.026 1.026 0 0 1 .198-1.302l.098-.074 1.305-.863H.466c-.314 0-.465-.292-.466-.619-.008-3.393 1.747-6.445 3.802-7.919.266-.19.537-.368.81-.54l.414-.25L.778 6.814l.242-.427a.944.944 0 0 1 1.221-.405l.1.054L6.56 8.641c1.292-.575 2.605-.93 3.851-.984l.338-.008h9.116l.36-.237V4.334a.824.824 0 0 0-.7-.828l-.101-.007H9.617c-.494 0-.9-.387-.956-.886l-.007-.117V2h10.769ZM6.437 10.31c-2.41 1.232-4.658 3.445-5.075 6.634l-.035.322h3.98l5.987-3.955-4.857-3Zm6.247 3.86-4.687 3.096h9.7l-5.013-3.097Zm7.541-4.982-6.175 4.08 6.175 3.814V9.188Zm-2.63-.039h-6.846c-.674 0-1.452.12-2.267.355l-.352.107 4.53 2.8 4.935-3.262Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { productCareDoNotIronIconIcon as default };
//# sourceMappingURL=productCareDoNotIronIconIcon.js.map
